export const DOCUMENT_DATA = 'DOCUMENT_DATA';
export const ADD_DOCUMENT = 'ADD_DOCUMENT';
export const DOCUMENT_DASHBOARD_LENGTH = 'DOCUMENT_DASHBOARD_LENGTH';

export const GET_FIELDS_FOR_DOCUMENT = 'GET_FIELDS_FOR_DOCUMENT';
export const SET_UPDATE_FIELDS_FOR_DOCUMENT = 'SET_UPDATE_FIELDS_FOR_DOCUMENT';
